import * as Splide from '@splidejs/splide';

export class SplideIntegration {
	constructor(protected target: string, protected options = {}) {

	}

	initSplide() {
		new Splide.default(this.target, {...{rewind: true}, ...this.options}).mount();
	}
}
